import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=a5c39152&scoped=true&"
import script from "./SingleSelect.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SingleSelect.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=a5c39152&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c39152",
  null
  
)

export default component.exports